<template>
    <div>
        <div v-if="list && !id">
            <div class="row justify-content-center">
                <div class="col-md-12 mb-3">
                    <h1 class="text-uppercase sb-main-header">Learning Center</h1>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <img src="/images/learning_center.jpg" alt="Person using a tablet" class="embed-responsive"/>
                </div>
            </div>
            <div class="row justify-content-center mt-3">
                <div class="col-md-12 text-center mb-4">
                    <div class="accordion sb-accordion" id="accordionExample">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <h2 class="mb-0">
                                    <button class="btn dropdown-toggle sb-learning-center-dropdown-item" type="button" data-toggle="collapse" @click="categoryDropDown=!categoryDropDown" aria-expanded="true" aria-controls="collapseOne">
                                        Select A Category <small>({{selectedCategory?selectedCategory:'All'}})</small> <span class="caret"></span>
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseOne" :class="categoryDropDown?'collapse show':'collapse'" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <a class="dropdown-item sb-learning-center-dropdown-item" @click="omniSearch.category='';categoryDropDown=false;renderList(route);selectedCategory=''">
                                        All
                                    </a>
                                    <div v-if="permanentCategories.length > 0">
                                        <a
                                            v-for="category in onlyActives(permanentCategories)"
                                            v-if="permanentContents.some(e => e.sco_catid === category.dop_id)"
                                            class="dropdown-item sb-learning-center-dropdown-item"
                                            @click="omniSearch.category = category.dop_id; categoryDropDown = false; renderList() ; selectedCategory = category.dop_name"
                                            :id="'category_link_' + category.dop_id"
                                        >
                                            {{category.dop_name}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 mb-3" v-for="content in contents">
                    <div class="card border-0">
                        <div
                            class="sb-learning-center"
                            :style="content.sco_featimg?'background:url('+encodeURI(content.sco_featimg)+')no-repeat center center;background-size: cover;':'background:url(/images/sb_resource.png)no-repeat center center;background-size: cover;'"
                            role="img"
                            aria-label="image"
                        >
                            <!--                            <img :src="content.sco_featimg?content.content_path+'/'+content.sco_featimg:'/images/sb_resource.png'" class="embed-responsive pb-2">-->
                            <div class="carousel-caption text-center">
                                <span>{{content.sco_title}}</span>
                                <br/>
                                <div class="text-center">
                                    <a tabindex="0"
                                       class="btn btn-primary btn-sb"
                                       href="#"
                                       @click.prevent="show(content)"
                                       :aria-label="((content.sco_title) + ' - Learn More')">Learn more</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="row">
                <div class="col-md-12 text-right">
                    <div class="pagination pull-right">
                        <button v-if="false" class="btn btn-default" @click="renderList(paginate.prev_page_url)" :disabled="!paginate.prev_page_url">
                            Previous
                        </button>
                        <button
                            v-for="n in paginate.last_page"
                            @click="renderList(route + '?page=' + n)"
                            :class="{'btn-info': paginate.current_page == n}"
                            class="btn btn-default"
                        >
                            {{n}}
                        </button>
                        <button v-if="false" class="btn btn-default" @click="renderList(paginate.next_page_url)" :disabled="!paginate.next_page_url">Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="view">
            <div v-if="content" class="row justify-content-center">
                <div class="col-md-9 mb-3">
                    <h1 class="text-uppercase sb-main-header">Learning Center <i class="ml-3 mr-3 fas fa-angle-right"></i>  <span>{{findCategoryName(content.sco_catid)}}</span> </h1>
                </div>
                <div class="col-md-3 text-right">
                    <a
                        class="btn btn-primary btn-sb-blue"
                        tabindex="0"
                        href="#"
                        @click.prevent="render('list')">Back To Learning Center
                    </a>
                </div>
            </div>
            <div class="row justify-content-center sb-wt-bg">
                <div class="col-md-12">
                    <div  class="main-content-image mt-3" :style="content.sco_featimg?'background:url('+encodeURI(content.sco_featimg)+')no-repeat center center;background-size: cover;':'background:url(/images/sb_resource.png)no-repeat center center;background-size: cover;'"></div>
                </div>
            </div>
            <div class="row justify-content-center pt-4 sb-wt-bg pb-4">
                <div class="col-md-12 sb-learning-center-content">
                    <h3 class="text-center">{{content.sco_title}}</h3>
                    <div class="ql-editor" v-html="preparedDesc(content.sco_desc_long)"></div>
                    <div class="text-left">
                        <a v-if="content.file" class="btn btn-primary btn-sb" :href="content.content_path+'/'+content.file" target="_blank">View Document</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>

<script>
module.exports = {
    data() {
        return {
            route: '/api/content',
            view: false,
            list: !this.view,
            categoryDropDown:false,
            orderBy: 'created_at',
            order: 0,
            contents: [],
            content:false,
            categories: [],
            features: [],
            omniSearch: { category: '',status:'A' },
            search: {},
            paginate: {},
            selectedCategory:'',
            perPage: 9,
            perPageOptions: [
                { text: '10', value: '10' },
                { text: '25', value: '25' },
                { text: '50', value: '50' },
                { text: '100', value: '100' }
            ],
            permanentCategories: 'waiting',
            permanentContents: []
        }
    },
    props:['id'],
    mounted: function () {
        this.renderList();
        this.loadData();
    },
    computed: {
    },
    methods: {

        onlyActives(categories){
            var data=_.map(categories, function(o) {
                if (o.dop_status == "A") return o;
            })
            return _.without(data, undefined)
        },

        findCategoryName(cat_id){
            var cat=_.find(this.categories, function(chr) {
                return chr.dop_id == cat_id;
            });

            // return cat.dop_name  - cat can be undefined 26477596?c=13501530
            return cat?.dop_name || '';
        },

        renderList(page_url) {
            let params = {
                orderBy: this.orderBy,
                order: ( this.order == 1 ) ? 'asc' : 'desc',
                perPage: this.id?'1000':this.perPage,
                search: this.omniSearch
            }

            page_url = page_url || this.paginate.current_page_url || this.route
            this.$http.get(page_url, {params : params}).then(function (response) {
                this.contents = response.data.data
                if (this.permanentContents.length < 1) {
                    this.permanentContents = this.contents;
                }
                this.makePagination(response.data)
                if (this.id) {
                    var id = this.id
                    var content=_.find(this.contents, function(content) {
                        return content.sco_id === id;
                    });
                    this.show(content)
                }
            })
        },

        loadData() {
            this.$http.get(this.route + '/load-category' ).then(function (response) {
                this.categories = _.sortBy(response.data, [
                    function (item) { return item.dop_name; }
                ], ["asc"]);
                if(this.permanentCategories === 'waiting') {
                    this.permanentCategories = this.categories;
                }
            })
        },

        makePagination(data){
            this.paginate = data
            this.paginate.current_page_url = this.route + '?page=' + this.paginate.current_page
        },

        show(content) {
            content.sco_desc_long=content.sco_desc_long.replace("<iframe", "<iframe width='100%' height='500px'");
            this.content=content
            this.render('view')
        },

        render(param) {
            switch (param) {
                case 'list':
                    if (this.id) {
                        // There's flawed logic in here for going back to the list view when this component was
                        // rendered with an id passed in (id came directly from route '/learning-center/{id}')
                        // In that case, do a redirect to the learning-center route so that everything is loaded.
                        window.location.href = '/learning-center'
                        break;
                    } else {
                        $('.has-error').removeClass('has-error')
                        $('.help-block').remove()
                        this.view = false
                        this.list = !this.view
                        break;
                    }
                case 'view':
                    $('.has-error').removeClass('has-error')
                    $('.help-block').remove()
                    this.view = true
                    this.list = !this.view
                    break;
                default:
                    this.view = false
                    this.list = !this.view
                    this.resetForm()
            }
        },

        sortBy(param) {
            this.order = this.order * -1
            this.orderBy = param
            this.renderList()
        },
        preparedDesc(desc) {
            return this.changeColorsForSection508(desc);
        },
        changeColorsForSection508(desc) {
            const colorMap = {
                'rgb(127, 127, 127)': '#767676',
            };

            Object.entries(colorMap).forEach(([oldColor, newColor]) => {
                const styleRegex = new RegExp(`style="([^"]*color:\\s*${oldColor.replace(/[()]/g, '\\$&')}[^"]*)"`,'g');
                const colorRegex = new RegExp(`color:\\s*${oldColor.replace(/[()]/g, '\\$&')}`,'g');

                desc = desc.replace(styleRegex, (match, styleContent) => {
                    return `style="${styleContent.replace(colorRegex, `color: ${newColor}`)}"`;
                });

                desc = desc.replace(colorRegex, `color: ${newColor}`);
            });

            return desc;
        }
    }
}
</script>
